import { render, staticRenderFns } from "./MiniHeroForm.vue?vue&type=template&id=db09112c&"
import script from "./MiniHeroForm.vue?vue&type=script&lang=js&"
export * from "./MiniHeroForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports